import { Button } from "@/components/ui/button";
import AuthHeader from "@/features/auth/components/AuthHeader";
import { useCreateEvent } from "@/features/events/hooks/useCreateEvent";
import { EventType } from "@/features/events/types/EventType";
import AuthPageLayout from "@/features/platform-layout/components/AuthPageLayout";
import { useEffect } from "react";
import { useForgotEmail } from "../hooks/useForgotEmail";

const ForgotEmail = () => {
    const { sendEvent } = useCreateEvent()

    const { onBackButtonClick, onContactUsClick, onToHomepageClick } = useForgotEmail()

    useEffect(() => {
        void sendEvent({
            event: EventType.PAGE_VIEW,
            sub_category: "forgot_email_page",
        })
    }, [])

    // ********************************************************************************

    return (
        <AuthPageLayout>
            <AuthHeader
                onBackClick={onBackButtonClick}
            />
            <div className="w-full flex-1 flex flex-col items-center justify-center mt-[80px] overflow-hidden">
                <div className="w-full sm:w-[328px] md:w-[400px] lg:w-[500px] p-[20px] bg-white">
                    <div className="flex flex-col items-center bg-white p-[20px] space-y-[20px]">
                        <div className="font-bold text-2xl">
                            E-mail dimenticata
                        </div>
                        <div className="w-[328px] font-normal text-base text-center">
                            Se sei sicuro di avere un account attivo ma non ricordi la tua mail di accesso scrivici a <span className="text-holifya-blue">support@holifya.com</span>.
                        </div>
                        <div className="w-[328px] font-normal text-base text-center">
                            Il nostro team cercherà di aiutarti a recuperarla.
                        </div>
                        <Button
                            size={'form'}
                            onClick={onContactUsClick}
                        >
                            Scrivici
                        </Button>
                        <Button variant={'white'} size={'form'} onClick={onToHomepageClick}>
                            Vai al login
                        </Button>
                    </div>
                </div>
            </div>
        </AuthPageLayout>
    )
}

export default ForgotEmail
